import { createGlobalStyle } from 'styled-components/macro';

export const GlobalStyle = createGlobalStyle`
  *, body, span, p, a, div, pre, :after {
  box-sizing: border-box;
  font-family: MPLUSRounded1c-Regular !important;
}
`;
